// Simplified Add Idea form configuration - only steps 1 and 2 from the original flow
export const simpleAddIdeaForm = [
  {
    id: "1",
    name: "Who needs your help?",
    list: [
      {
        id: "11",
        cols: "2",
        fields: [
          {
            id: "111",
            modelField: "description",
            label:
              'Describe the group or groups of people that might need your help. If you were starting <strong>Uber</strong>, you\'d say "<em>People that need a ride and people willing drive others.</em>" If you were starting <strong>a salon for women</strong>, you might say "<em>Women that need their hair cut or styled.</em>"',
            inputType: "TEXTAREA",
            isHtml: true,
            isRequired: true,
            placeholder: "Describe your target customer groups",
            cols: "1",
          },
        ],
      },
    ],
    modelForBox: {
      // still need to figure out
      content: "sample text with binded fields",
    },
  },
  {
    id: "2",
    name: "Problem",
    description: "What do {description} need your help with?",
    list: [
      {
        id: "41",
        fields: [
          {
            id: "411",
            modelField: "desireVerb",
            addon: "They",
            inputType: "DROPDOWN_WITH_ADDON",
            placeholder: "i.e. need to, want to",
            options:
              '[{"id": 1, "name": "desperately need to", "value": "DESPERATELY_NEED_TO"},{"id": 2, "name": "have to", "value": "HAVE_TO"},{"id": 3, "name": "need to", "value": "NEED_TO"},{"id": 4, "name": "want to", "value": "WANT_TO"},{"id": 5, "name": "should", "value": "SHOULD"},{"id": 6, "name": "don\'t want to", "value": "DONT_WANT_TO"},{"id": 7, "name": "won\'t", "value": "WONT"}]',
          },
        ],
      },
      {
        id: "42",
        fields: [
          {
            id: "421",
            modelField: "desireReason",
            placeholder: "i.e. go to the grocery store OR manage their money",
            inputType: "AUTOCOMPLETE",
            options: "[]",
            isNotMark: true,
            isRequired: true,
          },
        ],
      },
      {
        id: "43",
        fields: [
          {
            id: "431",
            modelField: "problemVerb",
            addon: "but",
            inputType: "TAGS_WITH_ADDON",
            options: JSON.stringify([
              { id: 1, name: "it takes too long", label: "it takes too long" },
              { id: 2, name: "it costs too much", label: "it costs too much" },
              {
                id: 3,
                name: "it's too complicated",
                label: "it's too complicated",
              },
              { id: 4, name: "it's not reliable", label: "it's not reliable" },
              {
                id: 5,
                name: "it's not available when needed",
                label: "it's not available when needed",
              },
              {
                id: 6,
                name: "it doesn't work well",
                label: "it doesn't work well",
              },
              { id: 7, name: "it's too slow", label: "it's too slow" },
              {
                id: 8,
                name: "it's too expensive",
                label: "it's too expensive",
              },
              { id: 9, name: "it's hard to find", label: "it's hard to find" },
              {
                id: 10,
                name: "it's not convenient",
                label: "it's not convenient",
              },
            ]),
            isObject: true,
            placeholder: "i.e. it takes too long, it cost too much",
            isNotAdd: false,
          },
        ],
      },
      {
        id: "44",
        fields: [
          {
            id: "441",
            addon: "because",
            modelField: "problemReason",
            placeholder: "i.e. there aren't any stores near by",
            inputType: "TEXT_WITH_ADDON",
          },
        ],
      },
    ],
    modelForBox: {
      // still need to figure out
      content: "sample text with binded fields",
    },
  },
  {
    id: "3",
    name: "Summary",
    description: "✨ We're getting your idea all set up!",
    list: [
      {
        id: "31",
        fields: [
          {
            id: "311",
            modelField: "summary",
            inputType: "SUMMARY_CHECKLIST",
            options: JSON.stringify([
              "Defining your target customers",
              "Determining your estimated market size",
              "Finding the best places to look for contacts",
              "Creating your opportunity map",
            ]),
          },
        ],
      },
    ],
  },
];
